module.exports = __webpack_public_path__ + "static/media/unboxing_spring_1.34f5d876.jpg";